<script lang="ts">
  import { Consultorios, type Profesional } from '../lib/api';

  let profesionales = $state<Profesional[]>([]);
  let error = $state<string|null>(null);
  let cargando = $state(false);

  let nuevoProf = $state<Profesional>({ nombre:'', colegiado:'', nit:'', tipoRelacion:'EMPLEADO', honorarioPct:100, activo:true });

  async function recargar() {
    cargando = true; error = null;
    try { profesionales = await Consultorios.profesionales(false); }
    catch (e: any) { error = e.message; }
    cargando = false;
  }

  async function crearProfesional() {
    error = null;
    if (!nuevoProf.nombre) { error = 'Nombre del profesional requerido'; return; }
    try {
      await Consultorios.crearProf({ ...nuevoProf });
      nuevoProf = { nombre:'', colegiado:'', nit:'', tipoRelacion:'EMPLEADO', honorarioPct:100, activo:true };
      await recargar();
    } catch (e: any) { error = e.message; }
  }

  async function toggleProfesional(p: Profesional) {
    try { await Consultorios.actualizarProf(p.id!, { ...p, activo: !p.activo }); await recargar(); }
    catch (e: any) { error = e.message; }
  }

  $effect(() => { recargar(); });
</script>

<section class="page">
  <h2>Profesionales</h2>
  <p class="sub">Gestione los médicos y profesionales que atienden en su clínica.</p>

  {#if error}<div class="err">{error}</div>{/if}

  <div class="card">
    <h3>Nuevo profesional</h3>
    <div class="form">
      <input placeholder="Nombre completo" bind:value={nuevoProf.nombre}/>
      <input placeholder="Colegiado" bind:value={nuevoProf.colegiado}/>
      <input placeholder="NIT" bind:value={nuevoProf.nit}/>
      <div class="row">
        <select bind:value={nuevoProf.tipoRelacion}>
          <option value="EMPLEADO">Empleado</option>
          <option value="INDEPENDIENTE">Independiente</option>
        </select>
        <input type="number" min="0" max="100" step="0.01" placeholder="% honorario" bind:value={nuevoProf.honorarioPct}/>
      </div>
      <button onclick={crearProfesional}>Crear profesional</button>
    </div>
  </div>

  <div class="card" style="margin-top:16px">
    <h3>Lista de profesionales</h3>
    <table>
      <thead><tr><th>Nombre</th><th>Colegiado</th><th>NIT</th><th>Relación</th><th>% honorario</th><th>Activo</th><th></th></tr></thead>
      <tbody>
        {#each profesionales as p (p.id)}
          <tr class:off={!p.activo}>
            <td>{p.nombre}</td>
            <td>{p.colegiado ?? '—'}</td>
            <td>{p.nit ?? '—'}</td>
            <td>{p.tipoRelacion}</td>
            <td>{p.honorarioPct ?? 100}%</td>
            <td>{p.activo ? 'Sí' : 'No'}</td>
            <td><button onclick={() => toggleProfesional(p)}>{p.activo ? 'Desactivar' : 'Activar'}</button></td>
          </tr>
        {/each}
        {#if profesionales.length === 0 && !cargando}<tr><td colspan="7">No hay profesionales registrados.</td></tr>{/if}
      </tbody>
    </table>
  </div>
</section>

<style>
  .page { padding: 16px; max-width: 720px; }
  h2 { margin: 0 0 4px; font-size: 22px; }
  .sub { color: #64748b; font-size: 13px; margin: 0 0 20px; }
  .err { background: #fef2f2; color: #dc2626; padding: 10px 14px; border-radius: 8px; margin-bottom: 12px; font-size: 13px; }

  .card { background: #fff; border: 1px solid rgba(0,0,0,0.05); border-radius: 12px; padding: 24px; }
  .card h3 { font-size: 16px; margin: 0 0 12px; color: #0f172a; }

  .form { display: flex; gap: 8px; flex-wrap: wrap; align-items: end; }
  .form input, .form select {
    padding: 8px 12px; border: 1.5px solid rgba(0,0,0,0.08); border-radius: 8px;
    font: inherit; font-size: 13px; background: #fff; flex: 1; min-width: 120px;
  }
  .form input:focus, .form select:focus { outline: none; border-color: #0f766e; }
  .form button {
    padding: 8px 16px; background: #1e293b; color: #fff; border: 0; border-radius: 8px;
    font: inherit; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap;
  }
  .form button:hover { background: #0f172a; }
  .row { display: flex; gap: 8px; flex: 1; min-width: 200px; }

  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 12.5px; }
  th { text-align: left; padding: 8px 10px; border-bottom: 2px solid rgba(0,0,0,0.05); color: #64748b; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.03em; }
  td { padding: 8px 10px; border-bottom: 1px solid rgba(0,0,0,0.04); }
  tr.off td { color: #94a3b8; }
  td button {
    padding: 4px 10px; background: none; border: 1px solid rgba(0,0,0,0.1); border-radius: 6px;
    font: inherit; font-size: 11px; font-weight: 600; cursor: pointer; color: #475569;
  }
  td button:hover { background: #f1f5f9; color: #0f172a; }
</style>
